<template>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-if="! is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-else-if="! team">
        <p>No detail data found.</p>
    </div>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0" v-else>
        <div class="tab-content main-tabs-content">
            <div class="tab-pane fade show active">
                <header class="info-sub-head">
                    <!--					<div class="image-box">
                                                                    <img :src="team.flag" alt="team" />
                                                            </div>-->
                    <div class="info-body">
                        <div class="info-body-left">
                            <h1>{{ team.name }}</h1>
                            <time class="time" datetime="2020-02-11">{{ tournament.name }}</time>
                        </div>
                        <div class="info-body-right" style="margin-top: 30px;margin-bottom: -20px;">
                            <div class="team-logo">
                                <img width="90" height="90" class="lazyload" :src="team.flag.resizeImage(90,90)" alt="team logo" />
                            </div>
                        </div>
                    </div>
                </header>
                <div class="nav-tabs-wrap">
                    <ul class="nav nav-tabs" role="tablist">
                        <li><router-link :to="{name: 'teamDetail.Matches'}" :class="{'active' : $route.name=='teamDetail.Matches'}">Matches</router-link></li>
                        <li><router-link :to="{name: 'teamDetail.Standings'}" :class="{'active' : $route.name=='teamDetail.Standings'}">Standings</router-link></li>
                        <li><router-link :to="{name: 'teamDetail.Results'}" :class="{'active' : $route.name=='teamDetail.Results'}">Results</router-link></li>
                        <li><router-link :to="{name: 'teamDetail.Players'}" :class="{'active' : $route.name=='teamDetail.Players'}">Players</router-link></li>
                        <li><router-link :to="{name: 'teamDetail.social'}" :class="{'active' : $route.name=='teamDetail.social'}">Social</router-link></li>
                    </ul>
                    <div class="dropdown sort-dropdown" v-if="$route.name == 'teamDetail.Matches'">
                        <span class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" href="javascript:;">
                            Sort by <i class="ico-down-arrow"></i>
                        </span>
                        <div class="dropdown-menu">
                            <button type="button" class="dropdown-item" :class="{all: sortBy == 'Live'}" @click="sortMatchesBy('Live')">
                                Live
                            </button>
                            <button type="button" class="dropdown-item" :class="{all: sortBy == 'Stumps'}" @click="sortMatchesBy('Stumps')">
                                Stumps
                            </button>
                            <button type="button" class="dropdown-item" :class="{all: sortBy == 'Cancelled'}" @click="sortMatchesBy('Cancelled')">
                                Cancelled
                            </button>
                            <button type="button" class="dropdown-item" :class="{all: sortBy == 'Finished'}" @click="sortMatchesBy('Finished')">
                                Finished
                            </button>
                            <button type="button" class="dropdown-item" :class="{all: sortBy == ''}" @click="sortMatchesBy('')">
                                All Moments
                            </button>
                        </div>
                    </div>
                </div>
                <div class="tab-content">
                    <router-view />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'teamDetail',

        data() {
            return {
                sortBy: '',
                team: null,
                tournament: null
            }
        },
        metaInfo() {
            if (!this.team)
                return
            let title = this.team.name + " - " + this.tournament.name + " - Planet Cricket";
            let description = this.team.name + " - " + this.tournament.name + " - Planet Cricket";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
        },

        methods: {
            main() {
                return this.$axios
                        .get(this.$TEAM_DETAIL_API.replace(':tournament', this.$route.params.tournament).replace(':team', this.$route.params.team))
                        .then(response => {
                            this.is_data_ready = true
                            this.team = response.data.result.team
                            this.tournament = response.data.result.tournament
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
            sortMatchesBy(sort) {
                this.sortBy = sort
                Components['teamMatches'].getMatches(sort)
            }
        }
    }
</script>

